<div class="container-fluid">
    <img src="assets/images/logo-dark.png" alt="Logo" class="logo">
  </div>
<div class="row">
  <!-- Cash In Per Day Card -->
  <div class="col-md-4">
    <div class="card border shadow-sm" (click)="showStats = !showStats">
      <div class="card-body text-center">
        <h6 class="text-muted">Cash In Per Day</h6>
        <h2 class="mb-2">${{averageCashInPerDayPerFilteredBoard.toFixed(2)}}</h2>
        <span class="badge bg-success text-white">
          <i class="mdi mdi-trending-flat"></i> Average
        </span>
        <p class="text-muted mb-0">Current Period</p>
      </div>
    </div>
  </div>

  <!-- Net In Per Day Card -->
  <div class="col-md-4">
    <div class="card border shadow-sm" (click)="showStats = !showStats">
      <div class="card-body text-center">
        <h6 class="text-muted">Net In Per Day</h6>
        <h2 class="mb-2">${{averageNetPerDayPerFilteredBoard.toFixed(2)}}</h2>
        <span class="badge bg-success text-white">
          <i class="mdi mdi-trending-flat"></i> Average
        </span>
        <p class="text-muted mb-0">Current</p>
      </div>
    </div>
  </div>
  <!-- Game Stats Card -->
<div class="col-md-4">
  <div class="card border shadow-sm" (click)="showGameStats = !showGameStats">
    <div class="card-body text-center">
      <h6 class="text-muted">Game Stats</h6>
      <h2 class="mb-2">
        <i class="mdi mdi-gamepad-variant"></i>
      </h2>
      <span class="badge bg-success text-white">
        <i class="mdi mdi-trending-flat"></i> Click to {{ showGameStats ? 'Hide' : 'Show' }}
      </span>
      <p class="text-muted mb-0">Grouped by Game</p>
    </div>
  </div>
</div>
</div>


<!-- Game Stats Table (Collapsible) -->
<div class="col-md-12" *ngIf="showGameStats">
  <div class="card border shadow-sm mt-3">
    <div class="card-body text-center">
      <h6 class="text-muted text-center">Detailed Game Statistics</h6>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>Game Name</th>
              <th>Count</th>
              <th>Cash In</th>
              <th>Cash Out</th>
              <th>Net Revenue</th>
              <th>Turnover</th>
              <th>Credit Won</th>
              <th>Games Played</th>
              <th>Games Won</th> 
              <th>Payout Percentage</th>            
              <th>Days Since Last Read</th>
              <th>Cash In / Day</th>
              <th>Net  / Day</th>              
              <th>RPT</th>
              <th>Bet Multiplier</th>
              <th>Bet / Play</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let gameKey of gameList">
              <td><strong>{{ gameKey }}</strong></td>
              <td>{{ (boardStatsByGame.get(gameKey)?.count || 0).toFixed(0) }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.totalCashin || 0) | number:'1.0-0' }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.totalCashout || 0) | number:'1.0-0' }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.totalNet || 0) | number:'1.0-0' }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.totalCoinIn || 0) | number:'1.0-0' }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.totalCoinOut || 0) | number:'1.0-0' }}</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.totalGamesPlayed || 0) | number:'1.0-0' }}</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.totalGamesWon || 0) | number:'1.0-0' }}</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.payoutRatio * 100 || 0) | number:'1.0-0' }}%</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.avgDays || 0) | number:'1.0-0' }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.avgDailyCashIn || 0).toFixed(0) }}</td>
              <td>${{ (boardStatsByGame.get(gameKey)?.avgDailyNet || 0) | number:'1.0-0' }}</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.rpt * 100 || 0) | number:'1.0-0' }}%</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.betMultiplier || 0) | number:'1.0-2' }}</td>
              <td>{{ (boardStatsByGame.get(gameKey)?.betPerPlay || 0) | number:'1.0-2' }}</td>           
            </tr>
          </tbody>
        </table>
      </div>

      <span class="badge bg-info text-white">
        <i class="mdi mdi-chart-box"></i> Grouped by Game
      </span>
    </div>
  </div>
</div>


<div *ngIf="showStats" class="main-card-container">
  <div class="card">
    <div class="card-body">
      <div class="dropdown float-end" ngbDropdown>
        <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
          data-toggle="dropdown" aria-expanded="false">
          <i class="mdi mdi-dots-vertical"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item">Export Board Stats</a>  
        </div>
        <i class="mdi mdi-refresh" (click)="refresh()" ngbTooltip="Refresh"></i>
      </div>
      <h4 class="card-title mb-4">Board Stats </h4>
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <input 
                type="text" 
                name="searchTerm" 
                class="form-control form-control-sm ms-2"
                aria-controls="tickets-table" 
                [(ngModel)]="term" 
                (ngModelChange)="onSearch()" />
            </label>
          </div>
      </div>
      <div class="date-picker-container">
        <div class="form-group">
          <label for="startDate">Start Date</label>
          <input type="text"
                 id="startDate"
                 class="form-control"
                 placeholder="yyyy-mm-dd"
                 ngbDatepicker
                 #startDatePicker="ngbDatepicker"
                 [(ngModel)]="statsStartDate"
                 (dateSelect)="onDateChange()"
                 (click)="startDatePicker.toggle()">
        </div>
      
        <div class="form-group">
          <label for="endDate">End Date</label>
          <input type="text"
                 id="endDate"
                 class="form-control"
                 placeholder="yyyy-mm-dd"
                 ngbDatepicker
                 #endDatePicker="ngbDatepicker"
                 [(ngModel)]="statsEndDate"
                 (dateSelect)="onDateChange()"
                 (click)="endDatePicker.toggle()">
        </div>    
        <button class="btn btn-primary" style="width: 25%; margin-top: 15px; margin-left: 0;">Refresh</button>
      </div>
    <div class="form-group">
  <label for="salesRepFilter">Sales Rep</label>
  <select 
    id="salesRepFilter" 
    class="form-control"
    [(ngModel)]="selectedSalesRep"
    (ngModelChange)="onSalesRepFilterChange()">
    <option [ngValue]="null">All</option>
    <option *ngFor="let sr of filteredSalesRepsArray" [ngValue]="sr">
      {{ sr.firstName || 'N/A' }} {{ sr.lastName || 'N/A' }}
    </option>
  </select>
</div>



      
      
      
      <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
        <table class="table table-centered">
            <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
            <tr>
              <th (click)="sortData('timeStamp')">Read Timestamp
                <span *ngIf="sortColumn === 'timeStamp'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('assetTag')">Asset Tag
                <span *ngIf="sortColumn === 'assetTag'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('fusionConnect')">Fusion Connect
                <span *ngIf="sortColumn === 'fusionConnect'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('serialNumber')" >Serial Number   
                <span *ngIf="sortColumn === 'serialNumber'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('salesRep')">Sales Rep
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('gameName')">Game Name
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('cashIn')">Cash In
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('cashOut')">Cash Out
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>

              </th>
              <th (click)="sortData('netRevenue')">Net Revenue
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>

              </th>
              <th (click)="sortData('coinIn')">Turnover
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>

              </th>
              <th (click)="sortData('coinOut')">Credit Won
                <span *ngIf="sortColumn === 'salesRep'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('gamesPlayed')">Games Played
                <span *ngIf="sortColumn === 'gamesPlayed'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('gamesWon')">Games Won
                <span *ngIf="sortColumn === 'gamesWon'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>  
              <th (click)="sortData('payoutPercentage')">Payout Percentage
                <span *ngIf="sortColumn === 'payoutPercentage'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>                 
              <th (click)="sortData('daysSincePrevRead')">Days Since Last Read
                <span *ngIf="sortColumn === 'daysSincePrevRead'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('cashIn/day')">Cash In / Day
                <span *ngIf="sortColumn === 'cashIn/day'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
              </th>
              <th (click)="sortData('netRevenue/day')">Net Revenue / Day
                <span *ngIf="sortColumn === 'netRevenue'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
                
              </th>
              <th (click)="sortData('rtp')">RTP
                <span *ngIf="sortColumn === 'rtp'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
                
              </th>
              <th (click)="sortData('rtp')">Bet Multiplier
                <span *ngIf="sortColumn === 'rtp'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
                
              </th>
              <th (click)="sortData('rtp')">Bet Per Play
                <span *ngIf="sortColumn === 'rtp'">
                  <i [ngClass]="{'fa fa-arrow-up': sortDirection, 'fa fa-arrow-down': !sortDirection}"></i>
                </span>
                
              </th>
              
              
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredStats">
              <td>{{ item.timeStamp | date}}</td>
              <td>
                <a href="javascript:void(0);" (click)="openBoardStatsModal(item.board?.assetTag)">
                  {{ item.board?.assetTag }}
                </a>
              </td>
              <td>{{item.board?.fusionConnect}}</td>
              <td>{{item.board?.serialNumber}}</td>
              <td>{{item.board?.location?.salesRep.firstName}} {{item.board?.location?.salesRep.lastName}}</td> 
              <td>{{item.board?.installedGamePackage?.name}}</td>
              <td>{{item.cashInDiff.toFixed(0)}}</td>
              <td>{{item.cashOutDiff.toFixed(0)}}</td>
              <td>{{item.profit?.toFixed(0)}}</td>
              <td>{{item.coinInDiff.toFixed(0)}}</td>
              <td>{{item.coinOutDiff.toFixed(0)}}</td>              
              <td>{{item.gamePlayedDiff.toFixed(0)}}</td>
              <td>{{item.gameWonDiff.toFixed(0)}}</td>  
              <td>{{ (item.holdPercentage * 100) | number: '1.0-2' }}%</td>                    
              <td>{{item.daysSincePrevRead}}</td>
              <td>
                {{ item.daysSincePrevRead ? (item.cashInDiff / item.daysSincePrevRead).toFixed(0) : 'N/A' }}
              </td>
              
              <td>{{ (item.profit / item.daysSincePrevRead).toFixed(0) }}</td>          
              <td>{{ (item.coinOutDiff / item.coinInDiff) * 100 | number: '1.0-0' }}%</td>
              <td>{{ (item.coinInDiff / item.cashInDiff).toFixed(2)  }}</td>           
              <td>{{ (item.coinInDiff / item.gamePlayedDiff).toFixed(2)}}</td>       
              
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
